<template>
	<div>
		<div :style="{backgroundImage: 'url(' + topImage + ')',height: '300px', backgroundPosition: 'center center',backgroundRepeat: 'no-repeat',backgroundSize: 'cover'}"></div>

		<div style="margin-top: 30px;margin-left: 20%;text-align: left;width: 60%;">
			<div v-if="news.length == 0" style="margin-top: 30px;text-align: center;margin-bottom:30px;">
				<div style="display: inline-block;padding:10px 200px 10px 200px;border-radius: 8px;background-color: #cdd1d9;color:white;">
					暂无信息
				</div>
			</div>
			<div @click="newsDetail(item.id)" v-for="item in news" style="display: inline-block;margin:2%;width:29.33%;height: 390px;vertical-align: top;" >
				<div class="messageBox">
					<el-image style="width: 100%; height: 150px;"
					:src="item.url"
					fit="cover">
					<div slot="placeholder" style="text-align:center;padding-top:30%;font-size:12px;color:#909399;">
					  加载中...
					</div></el-image>
					<div style="border-left: 1px solid #EBEEF5;border-bottom: 1px solid #EBEEF5;border-right: 1px solid #EBEEF5;">
						<div style="margin-bottom: 20px;margin-left: 5%;width: 90%;height: 50px;margin-top:15px;font-size: 20px;font-weight: bold;color:#409EFF;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;">{{item.title}}</div>
						<div style="margin-left: 5%;width: 90%;height: 75px;font-size: 14px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 4;">
							{{item.briefIntroduction}}
						</div>
						<div style="margin-left: 5%;width: 90%;height: 40px;font-size: 12px;margin-top:15px;">查看更多
						<i class="el-icon-right"></i>
						</div>
					</div>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	import utils from '@/utils';
	export default {
		name: '',
		data() {
			return {
				language:"Chinese",
				topImage:utils.fileUrl()+"newsCenter/topImage.jpg",
				title:"公司公告",
				news:[
					
					
				],
			}
		},
		methods: {
			newsDetail(id){
				utils.navigateTo(this.$router, "NewsDetail", null,{
					id:id
				});
			},
		},
		mounted() {
			let list = [];
			for(let i=0;i<this.$store.state.news.length;i++){
				if(this.$store.state.news[i].type == 3){
					list.push(this.$store.state.news[i]);
				}
			}
			this.news = list;
		}

	}
</script>
<style type="text/css">
	.messageBox{
		cursor: pointer;
		transition: all 0.2s;
		-moz-transition: all 0.2s;
		/* Firefox 4 */
		-webkit-transition: all 0.2s;
		/* Safari å’Œ Chrome */
		-o-transition: all 0.2s;
		/* Opera */
	}
	.messageBox:hover{
		margin-top:-15px;
	}
</style>